var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrpCls},[(_vm.onMounted)?_c('notice-icon',{staticStyle:{"cursor":"pointer","padding":"0 10px"}}):_vm._e(),_c('avatar-dropdown',{class:_vm.prefixCls,attrs:{"menu":_vm.showMenu,"current-user":{name: _vm.userName}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }